<template>
	<div class="com-pagetabs" :class="{'default-theme':!nostyle}" ref="tabs" @mousewheel="mousewheel">
		<div class="pagetabscon" ref="tabscon" :style="{transform:'translateX('+pagetabsLeft+'px)'}">
			<div class="pagetab" ref="tab" :class="{selected:$route.name==tab.name,'selected-prev':index<pagetabs.length-1&&$route.name==pagetabs[index+1].name}" v-for="(tab,index) in pagetabs" :key="index" 
				@click="redirect(tab)" @contextmenu.prevent="$refs.tabmenu[index].click(index)">
				<span>{{tab.title}}</span>
				<el-dropdown @command="tabCommand($event,index)" trigger="click" placement="top">
					<div ref="tabmenu"></div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="refresh">刷新</el-dropdown-item>
						<el-dropdown-item command="close" v-if="index!=0" divided>关闭</el-dropdown-item>
						<el-dropdown-item command="closeOther">关闭其他</el-dropdown-item>
						<el-dropdown-item command="closeLeft" v-if="index!=0">关闭左侧所有</el-dropdown-item>
						<el-dropdown-item command="closeRight" v-if="index!=pagetabs.length-1">关闭右侧所有</el-dropdown-item>
						<el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<i class="el-icon-close" v-if="index!=0" @click.stop="removeTab(index)"></i>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'com-pagetabs',
	props:{
		page:{type:Object},
		nostyle:{type:Boolean,default:false},
	},
	data(){
		return {
			pagetabsLeft:0,
			pagetabs:[{name:this.$getFirstPage().name,title:this.$getFirstPage().meta.title}]
		};
	},
	mounted(){
		this.changeTab(false,true);
	},
	watch:{
		'$route'(route){
			this.changeTab();
		}
	},
	methods:{
		redirect(tab){
			if(this.$route.name!=tab.name){
				this.$router.push({name:tab.name});
			}
		},
		mousewheel(e){
			var tabsWidth=this.$refs.tabs.clientWidth;
			var tabsconWidth=this.$refs.tabscon.clientWidth;
			
			var offset=100;
			if(e.deltaY>0){
				if(tabsconWidth<tabsWidth){
					offset=0;
				}
				else if(tabsconWidth-tabsWidth+this.pagetabsLeft<offset){
					offset=tabsconWidth-tabsWidth+this.pagetabsLeft;
				}
				this.pagetabsLeft-=offset;
			}
			else if(e.deltaY<0){
				if(tabsconWidth<tabsWidth&&this.pagetabsLeft==0){
					offset=0;
				}
				else if(-this.pagetabsLeft<offset){
					offset=-this.pagetabsLeft;
				}
				this.pagetabsLeft+=offset;
			}
		},
		removeTab(index){
			var tabs=this.pagetabs.splice(index,1);
			this.page.clearCache(tabs.map(p=>p.name));
			if(tabs[0].name==this.$route.name){
				this.$router.push({name:this.pagetabs[index-1].name});
			}
		},
		tabCommand(command,index) {
			if(command=='refresh'){
				this.page.refresh();
			}
			else if(command=='close'){
				this.removeTab(index);
			}
			else if(command=='closeOther'){
				var tabrs=this.pagetabs.splice(index+1);
				var tabs=this.pagetabs.splice(1,index-1);
				this.page.clearCache(tabs.concat(tabrs).map(p=>p.name));
				this.changeTab(true);
			}
			else if(command=='closeLeft'){
				var tabs=this.pagetabs.splice(1,index-1);
				this.page.clearCache(tabs.map(p=>p.name));
				this.changeTab(true);
			}
			else if(command=='closeRight'){
				var tabs=this.pagetabs.splice(index+1);
				this.page.clearCache(tabs.map(p=>p.name));
				this.changeTab();
			}
			else if(command=='closeAll'){
				var tabs=this.pagetabs.splice(1);
				this.page.clearCache(tabs.map(p=>p.name));
				this.$router.push({name:this.pagetabs[0].name});
			}
		},
		changeTab(isReset,isFirstLoad){
			let tabIndex=null;
			for(var i=0;i<this.pagetabs.length;i++){
				if(this.pagetabs[i].name==this.$route.name){
					tabIndex=i;
					break;
				}
			}
			if(tabIndex==null){
				if(isFirstLoad&&this.$route.meta.nofirstload){
					this.$router.replace({path:'/'});
				}
				else{
					this.pagetabs.push({name:this.$route.name,title:this.$route.meta.title});
				}
				tabIndex=this.pagetabs.length-1;
			}
			
			this.$nextTick(()=>{
				if(isReset){
					this.pagetabsLeft=0;
					return;
				}
				var tabsWidth=this.$refs.tabs.clientWidth;
				var tabsconStyle=getComputedStyle(this.$refs.tabscon);
				var tabStyle=getComputedStyle(this.$refs.tab[tabIndex]);
				var tabOffsetLeft=this.$refs.tab[tabIndex].offsetLeft-parseInt(tabStyle.marginLeft);
				if(tabIndex==0){
					tabOffsetLeft-=parseInt(tabsconStyle.paddingLeft);
				}
				var tabWidth=this.$refs.tab[tabIndex].offsetWidth+parseInt(tabStyle.marginLeft)+parseInt(tabStyle.marginRight);
				if(tabIndex==this.$refs.tab.length-1){
					tabOffsetLeft+=parseInt(tabsconStyle.paddingRight);
				}

				if(tabOffsetLeft<-this.pagetabsLeft){
					this.pagetabsLeft=-tabOffsetLeft;
				}
				else if(tabOffsetLeft>tabsWidth-this.pagetabsLeft-tabWidth){
					this.pagetabsLeft=tabsWidth-(tabOffsetLeft+tabWidth);
				}
			});
		}
	},
}
</script>

<style lang="scss">
.com-pagetabs.default-theme{
	height:38px;overflow:hidden;flex-shrink:0;position:relative;border-bottom:1px solid #DBDBDB;background:white;
	.pagetabscon{
		position:absolute;display:flex;white-space:nowrap;transition:transform .3s;padding:0 1px;
		.pagetab{
			color:#495060;margin:3px 2px;
			padding:5px 14px;font-size:14px;display:flex;align-items:center;cursor:pointer;border:1px solid #d8dce5;
			i{
				margin-left:8px;color:#bbbec3;transform:scale(.9); 
				&:hover{font-weight:bold;}
			}
			&.selected{
				background:#4CB7A3;color:white;border-color:transparent;
				i{color:white;}
				&:before{content:'';background:white;width:10px;height:10px;border-radius:50%;margin-right:8px;}
			}
		}
	}
}
</style>